<script setup lang="ts">
import { computed } from 'vue';
import { useTrip } from '@/stores/trip';
import { fmtTime } from '@/core/format';

/**
 * Carte de totaux compacte (temps de trajet, nuits, distance, étapes).
 * Affichée juste sous la liste d'étapes, au-dessus du récap détaillé.
 */
const trip = useTrip();

const totals = computed(() => trip.calendar.value.totals);

const items = computed(() => [
  {
    label: 'Temps de trajet',
    value: totals.value.unreachable ? '—' : fmtTime(totals.value.totalMin),
    accent: true,
  },
  {
    label: 'Nuits sur place',
    value: totals.value.totalNights,
  },
  {
    label: 'Distance',
    value: `${totals.value.totalKm.toLocaleString('fr-FR')} km`,
  },
  {
    label: 'Étapes',
    value: trip.state.routeStops.length,
  },
]);
</script>

<template>
  <div
    class="grid grid-cols-2 gap-3 p-4 bg-surface border border-DEFAULT rounded-md"
  >
    <div
      v-for="(it, i) in items"
      :key="i"
      class="space-y-1"
    >
      <div class="text-xs text-text-muted uppercase tracking-wider">
        {{ it.label }}
      </div>
      <div
        :class="[
          'font-display text-2xl leading-none',
          it.accent ? 'text-accent' : 'text-text',
        ]"
      >
        {{ it.value }}
      </div>
    </div>
  </div>
</template>
